import api from '../utils/axiosConfig';
import { Correlation, CorrelationDetail } from '../types';

export interface CorrelationsResponse {
  correlations: Correlation[];
  count: number;
  total: number;
}

export class CorrelationsService {
  static async getCorrelations(params?: {
    status?: string;
    client_id?: string;
    limit?: number;
    offset?: number;
  }): Promise<CorrelationsResponse> {
    const response = await api.get('/correlations/', {
      params: { status: 'open', ...params },
    });
    return response.data;
  }

  static async getCorrelationById(correlationId: string): Promise<CorrelationDetail> {
    const response = await api.get(`/correlations/${correlationId}`);
    return response.data;
  }

  static async updateStatus(
    correlationId: string,
    status: 'open' | 'dismissed' | 'escalated',
  ): Promise<Correlation> {
    const response = await api.patch(`/correlations/${correlationId}`, { status });
    return response.data;
  }

  /**
   * Remove a single alert from a correlation — only allowed when the alert is
   * linked purely by a derived (subnet-bucket) entity, never an exact match.
   * Returns the updated correlation, or null if it was deleted (fewer than 2
   * alerts remained).
   */
  static async removeAlert(correlationId: string, alertId: string): Promise<CorrelationDetail | null> {
    const response = await api.delete(`/correlations/${correlationId}/alerts/${alertId}`);
    return response.status === 204 ? null : response.data;
  }
}
